import cn from "classnames";
import { Select } from "components/shared/form";
import Loader from "components/shared/loader";
import React, { Component, Fragment } from "react";

const options = [{ value: "email", label: <span className="select-item select-item--mail">По email</span> }];

export default class Invite extends Component {
    state = {
        inputField: "",
        selectType: "email",
        shouldUpdate: false,
        isLoading: false,
    };

    renderSelect = () => {
        const props = {
            options: options,
            disabled: true,
            onChange: ({ name, value }) => this.setState({ [name]: value }),
            inputProps: { name: "selectType" },
            unClearable: true,
            unSearchable: true,
            arrowRenderer: null,
            value: this.state.selectType,
        };
        return <Select {...props} />;
    };

    renderInput = () => {
        const { inputField } = this.state;
        const placeholder = "Введите Email";
        const setValue = ({ target }) => {
            const { name } = target;
            let { value } = target;
            if (this.state.selectType === "phone") {
                value = value.replace(/[^+,\d]/g, "");
            }
            let shouldUpdate = false;
            if (target.value && target.value !== inputField) {
                shouldUpdate = true;
            }
            this.setState({ [name]: value, shouldUpdate });
        };
        const props = {
            value: inputField,
            name: "inputField",
            onChange: setValue,
            placeholder: placeholder,
            className: "form-control form-control-sm",
        };
        return <input {...props} />;
    };

    handleRes = (res) => {
        const { callback } = this.props;
        this.setState({ isLoading: false, inputField: "", shouldUpdate: false });
        if (res && callback) {
            callback(res);
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const { inputField, shouldUpdate } = this.state;
        const { makeRequest, data } = this.props;
        if (shouldUpdate) {
            const sending = { Email: inputField, ...data };
            this.setState({ isLoading: true });
            return makeRequest(sending).then((res) => this.handleRes(res));
        }
    };

    render() {
        const { shouldUpdate, isLoading } = this.state;
        const cname = cn("btn btn-brand", { disabled: !shouldUpdate });
        return (
            <form onSubmit={this.handleSubmit}>
                <p>Отправьте приглашение пользователю по email</p>
                {isLoading ? (
                    <Loader prefix="margin-center" />
                ) : (
                    <Fragment>
                        <div className="pb-3">{this.renderInput()}</div>
                        <div className="row">
                            <div className="col-sm-12 text-right">
                                <input type="submit" className={cname} value="Отправить" />
                            </div>
                        </div>
                    </Fragment>
                )}
            </form>
        );
    }
}
